import Layout from "../UI/Layout/Layout";
import Cube from "../UI/Cube/Cube";
import props from "../../redux/props";
import { useSelector } from "react-redux";
import rotateImage from "../../assets/image/cube/rotate.svg";
import rotateImageWhite from "../../assets/image/cube/rotate_white.svg";
import { ItemList } from "../UI/Cube/types";

type Props = {
  items: ItemList;
};

const CubePageTemplate: React.FC<Props> = ({ items }) => {
  const t = useSelector((s) => s[props.TRANSLATION]);

  return (
    <Layout headerTransparent disableHeaderPadding>
      <div className="h-[90vh]">
        <Cube items={items} />
      </div>
      <div className="absolute w-full bottom-10 flex flex-col gap-3 items-center">
        <img src={rotateImageWhite} className="h-7" alt="Rotate" />
        <div className="text-white text-sm text-center 2xl:hidden">
          {t.cube.rotate}
        </div>
        <div className="text-white text-sm text-center hidden 2xl:block">
          {t.cube.rotateDesktop}
        </div>
      </div>
    </Layout>
  );
};

export default CubePageTemplate;
